module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    ref: "myHeader",
    staticClass: "no-select"
  }, [_c('div', {
    staticClass: "header__member"
  }, [_c('div', {
    staticClass: "center-container"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('router-link', {
    staticClass: "btn-on-air",
    attrs: {
      "to": {
        name: 'onAir'
      }
    }
  }, [_c('span', [_vm._v("直播中 On Air")])]), _vm._m(0)], 1), (_vm.isLogin && _vm.getUser) ? _c('div', {
    staticClass: "pull-right user",
    on: {
      "mouseover": function($event) {
        _vm.userDropdown = true
      },
      "mouseout": function($event) {
        _vm.userDropdown = false
      }
    }
  }, [_c('div', {
    staticClass: "user--name"
  }, [_vm._v(_vm._s(_vm.getUser.info.nickname))]), _c('div', {
    staticClass: "user--avatar"
  }, [_c('img', {
    attrs: {
      "src": "http://linpohua.com/img/about/mypic.png",
      "src": _vm.getUser.info.picture_url
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDropdown),
      expression: "userDropdown"
    }],
    staticClass: "user-dropdown",
    on: {
      "click": function($event) {
        _vm.userDropdown = !_vm.userDropdown
      }
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'user'
      }
    }
  }, [_vm._v("察看票券")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ticketType'
      }
    }
  }, [_vm._v("BYOC 購票")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'selectArea'
      }
    }
  }, [_vm._v("劃位 / 座位圖")])], 1), _c('li', [_c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("登出")])])])]) : _c('div', {
    staticClass: "pull-right user"
  }, [_c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("登入")])])])]), _c('div', {
    staticClass: "header__main"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "center-container"
  }, [_c('router-link', {
    staticClass: "nav-logo pull-left",
    attrs: {
      "to": {
        name: 'homepage'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.navImages.logo
    },
    on: {
      "click": function($event) {
        _vm.navActiveStatus = 0
      }
    }
  })]), _c('div', {
    staticClass: "nav-social pull-right"
  }, [_c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ({
        el: '.gamily',
        offset: -100
      }),
      expression: "{el: '.gamily', offset: -100}"
    }],
    staticClass: "btn",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "gamily-logo"
  })]), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.fbShare
    }
  }, [_c('div', {
    staticClass: "fa fa-facebook"
  })]), _c('router-link', {
    staticClass: "btn btn--white-o btn-radius btn__go-buy",
    attrs: {
      "to": {
        name: 'ticketType'
      }
    }
  }, [_vm._v("BYOC 購票")]), _c('router-link', {
    staticClass: "btn btn--white-o btn-radius btn__go-buy",
    attrs: {
      "to": {
        name: 'selectArea'
      }
    }
  }, [_vm._v("劃位 / 座位圖")]), _c('router-link', {
    staticClass: "btn btn--white-o btn-radius btn__go-buy",
    attrs: {
      "to": {
        name: 'user'
      }
    }
  }, [_vm._v("察看票券")])], 1)], 1)]), _c('div', {
    staticClass: "header__bottom"
  }, [_c('nav', {
    staticClass: "nav-wrap",
    class: {
      'open': _vm.navToggle
    }
  }, [_c('ul', {
    staticClass: "center-container"
  }, _vm._l((_vm.navBtns), function(btn, index) {
    return _c('li', {
      class: {
        'actived': _vm.navActiveStatus === index
      },
      on: {
        "click": function($event) {
          _vm.goNav(btn, index)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: btn.link
        }
      }
    }, [_vm._v(_vm._s(btn.name))])], 1)
  }))]), _c('div', {
    staticClass: "btn__nav-switch"
  }, [_c('img', {
    attrs: {
      "src": _vm.navToggle ? '/static/nav-btn-on.png?1' : '/static/nav-btn.png?1'
    },
    on: {
      "click": _vm.changeNavToggle
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow-wrap"
  }, [_c('div', {
    staticClass: "arrow"
  }, [_vm._v("▲")]), _c('div', {
    staticClass: "arrow"
  }, [_vm._v("▲")]), _c('div', {
    staticClass: "arrow"
  }, [_vm._v("▲")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ecb2a7e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/vueHeader.vue
// module id = 578
// module chunks = 1